// extracted by mini-css-extract-plugin
export var divider = "_1t-0";
export var dividerText = "_1t-1";